











import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { footerState } from '../../client/stores/footer'
import Footer from '../../client/components/organisms/Footer.vue'
import { headerState } from '../../client/stores/header'


@Component({
  components: {
    Footer
  }
})
export default class ImportComponent extends Vue {

  get footerRender() {
    return footerState.dataRender
  }
}
